import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToolsService } from 'src/app/utils/tools.service';

@Component({
  selector: 'app-upload-file-movements-extends',
  templateUrl: './upload-file-movements-extends.component.html',
  styleUrls: ['./upload-file-movements-extends.component.css']
})
export class UploadFileMovementsExtendsComponent {
  item: any = null;
  fileUrlImage: any = null;

  constructor(public toolsService: ToolsService) {}

  init(data: any) {
    console.log(data);
    this.item = data;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
    }
  }

  onSubmit() {
    const formData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    formData.append('item', JSON.stringify(this.item));
    formData.append('url_image', this.fileUrlImage);
    console.log(formData);
    
  }

  close() {
    // this.item.reset();
  }
}
